import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PublicReceptionObject from '@/types/table/publicReceptionObject';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PublicReceptionObjectData extends PublicReceptionObject {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PublicReceptionObjectController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PublicReceptionObjectData>>(API_CONTEXT + '/app/publicReceptionObject/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PublicReceptionObjectData>(API_CONTEXT + '/app/publicReceptionObject/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/publicReceptionObject/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/publicReceptionObject/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/publicReceptionObject/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicReceptionObject/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicReceptionObject/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicReceptionObject/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicReceptionObject/deleteBatch', params, httpOptions);
  }
}
